<template>
    <td colspan="5">
        <div class="staff-table-form staff-group-table">
            <div class="staff-form-wrapper group-name-wrapper">
                <div class="wrapper">
                    <span v-if="$v.value.name.$invalid" class="tooltiptext to-top">{{
                        errorDisplay($v.value.name, { val: MAX_NAME_LENGTH })
                    }}</span>
                    <div class="input-with-insidelabel" :class="{ tooltiperror: $v.value.name.$invalid }">
                        <input
                            id="listenInStaffGrpName"
                            ref="groupName"
                            type="text"
                            :value="value.name"
                            @input="update('name', $event.target.value) && $v.value.name.$touch()"
                        />
                        <label for="listenInStaffGrpName">{{ $t('staff.groupsTab.placeholder.name') }}</label>
                    </div>
                </div>
                <div class="wrapper chkbox">
                    <input
                        id="assignable"
                        type="checkbox"
                        :checked="value.assignable"
                        :disabled="isAssigned(value.staff_group_id, false, 'groups')"
                        @change="update('assignable', $event.target.checked)"
                    />
                    <label for="assignable"></label>
                    <label for="assignable">{{ $t('staff.groupsTab.placeholder.usedInAssignments') }}</label>
                </div>
            </div>
            <div class="staff-form-wrapper group-members-wrapper">
                <div class="wrapper multiselect-wrapper" :class="{ tooltiperror: $v.value.users.$invalid }">
                    <span v-if="$v.value.users.$invalid" class="tooltiptext to-top">{{
                        errorDisplay($v.value.users, { val: MAX_MEMBERS_LIST })
                    }}</span>
                    <Multiselect
                        v-model="value.users"
                        :placeholder="$t('staff.groupsTab.placeholder.members')"
                        :multiple="true"
                        track-by="name"
                        :select-label="emptyLabel"
                        :deselect-label="emptyLabel"
                        :close-on-select="false"
                        :selected-label="emptyLabel"
                        :clean-on-close="true"
                        :options="filteredStaff"
                        :inactive-allowed="true"
                        label="name"
                        @input="updateMembers"
                    >
                        <span slot="noResult">{{ $t('common.noSearchResults') }}</span>
                    </Multiselect>
                </div>
                <input
                    type="hidden"
                    name="groupMembers"
                    @input="update('users', $event.target.value) && $v.value.users.$touch()"
                />
            </div>
            <div class="staff-form-wrapper group-comment-wrapper">
                <div class="wrapper">
                    <span v-if="$v.value.comment.$invalid" class="tooltiptext to-top">{{
                        errorDisplay($v.value.comment, { val: MAX_COMMENT_LENGTH })
                    }}</span>
                    <div
                        class="textarea-with-insidelabel has-5-rows"
                        :class="{ tooltiperror: $v.value.comment.$invalid }"
                    >
                        <textarea
                            id="listenInStaffGrpComments"
                            :value="value.comment"
                            @input="update('comment', $event.target.value) && $v.value.comment.$touch()"
                        ></textarea>
                        <label for="listenInStaffGrpComments">{{
                            $t('staff.groupsTab.placeholder.comment')
                        }}</label>
                    </div>
                </div>
            </div>
        </div>
    </td>
</template>

<script type="text/babel">
import Multiselect from 'moxa-vue-multiselect';
import orderBy from 'lodash-es/orderBy';
import mappingState from './../common/mappingState';
import {
    minimumLength,
    forbiddenStaffName,
    maximumNameLength,
    forbiddenNames,
    forbidden,
    maximumCommentLength,
    membersLimit,
    needStaffWithNumber,
    errorDisplay,
} from '../../validators';
import { MAX_NAME_LENGTH, MAX_COMMENT_LENGTH, MAX_MEMBERS_LIST } from '../../constants';

export default {
    components: {
        Multiselect,
    },

    mixins: [mappingState],

    constants: {
        MAX_NAME_LENGTH,
        MAX_COMMENT_LENGTH,
        MAX_MEMBERS_LIST,
    },

    props: {
        value: {
            type: Object,
            required: true,
        },
        staff: {
            type: Array,
            required: true,
        },
        isAssigned: {
            type: Function,
            required: true,
        },
        allStaffMembers: {
            type: Array,
            required: true,
        },
        allStaffGroups: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            emptyLabel: '',
        };
    },

    validations() {
        return {
            value: {
                name: {
                    minimumLength,
                    forbiddenStaffName,
                    maximumNameLength,
                    forbiddenNames: (val, rule) => {
                        rule = this.getExistedNames;
                        return forbiddenNames(val, rule);
                    },
                },
                users: {
                    membersLimit,
                    needStaffWithNumber: () =>
                        needStaffWithNumber({
                            value: this.value,
                            isAssigned: this.isAssigned(this.value.staff_group_id, false, 'groups'),
                        }),
                },
                comment: { forbidden, maximumCommentLength },
            },
            validStaffGroup: ['value.name', 'value.users', 'value.comment'],
        };
    },

    computed: {
        filteredStaff() {
            return orderBy(
                this.staff.filter(staff => !this.value.assignable || staff.assignable),
                'name'
            );
        },

        getExistedNames() {
            return this.getOtherStaffGroups().concat(
                this.allStaffMembers.map(item => ({ name: item.first_name }))
            );
        },
    },

    watch: {
        value: {
            handler() {
                this.setUnsavedChanges(true);
                this.$emit('updateValid', true);
                this.$nextTick(() => {
                    this.$emit('updateValid', !this.$v.validStaffGroup.$invalid);
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.groupName.select();
        });
    },
    methods: {
        errorDisplay,
        getOtherStaffGroups() {
            let currentGroupId = this.value.staff_group_id ? this.value.staff_group_id : null;
            return this.allStaffGroups.filter(item => item.staff_group_id !== currentGroupId);
        },

        updateMembers(item) {
            this.update('users', item);
        },

        update(field, item) {
            this.$emit('input', { ...this.value, [field]: item });
        },
    },
};
</script>
